/**
 * SizeToggle — the Expand / Minimise button on the review and Fix windows.
 *
 * "pane" is the view laid over the task pane; Expand opens it as a window
 * over Word. "window" is that Office window; Minimise puts it back over the
 * pane. Word cannot resize an open dialog, so the switch closes one and opens
 * the other; the pane holds the state, so nothing is lost.
 */

import type React from "react";
import { Button } from "../../ds/components";

export type ViewPlacement = "pane" | "window";

export const SizeToggle: React.FC<{ placement: ViewPlacement; onToggle?: () => void }> = ({ placement, onToggle }) => {
  if (!onToggle) return null;
  const expand = placement === "pane";
  return (
    <Button
      size="sm"
      onClick={onToggle}
      title={expand ? "Open over the whole Word window" : "Shrink back over the side panel"}
    >
      {expand ? "Expand" : "Minimise"}
    </Button>
  );
};

export default SizeToggle;
